import type { ModuleConfig } from '../types/config';
import type { PlatformModuleCatalogEntry } from '../services/api/types/modules';
import { resolvePlatformModuleComponent } from '../config/platformModuleComponents';
import { mergeStaffPeopleCatalog } from '../config/staffModuleAccess';
import { dedupeNavigationModules } from './navigationDedup';

export function catalogEntryToModuleConfig(entry: PlatformModuleCatalogEntry): ModuleConfig {
  return {
    id: entry.screen_id?.trim() || entry.module_code,
    name: entry.display_name,
    icon: entry.icon?.trim() || 'LayoutDashboard',
    path: entry.route_path?.trim() || '/',
    enabled: true,
    component: resolvePlatformModuleComponent(
      entry.module_code,
      entry.screen_id,
      entry.component
    ),
    // Visibility comes from DB module_access (canUserOpenModule) — no role names here.
    permissions: [],
    settings: { moduleCode: entry.module_code },
  };
}

/** Build sidebar routes from `GET /modules/catalog` (platform_modules in DB). */
export function buildNavigationModules(catalog: PlatformModuleCatalogEntry[]): ModuleConfig[] {
  const modules: ModuleConfig[] = [];

  for (const entry of mergeStaffPeopleCatalog(catalog)) {
    const path = entry.route_path?.trim();
    if (!path) continue;
    modules.push(catalogEntryToModuleConfig(entry));
  }

  return dedupeNavigationModules(modules);
}
